import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "-2 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.256 1.097 C 5.979 1.218,5.724 1.573,5.659 1.930 C 5.615 2.166,5.772 2.429,6.307 3.020 C 6.566 3.306,8.676 5.444,10.997 7.772 L 15.217 12.003 11.395 15.832 C 6.141 21.094,5.788 21.465,5.676 21.837 C 5.639 21.960,5.644 22.032,5.698 22.220 C 5.793 22.546,6.129 22.885,6.429 22.957 C 6.658 23.012,6.940 22.974,7.168 22.856 C 7.312 22.781,14.228 15.902,16.181 13.890 C 16.912 13.137,17.542 12.455,17.579 12.375 C 17.668 12.189,17.648 11.765,17.539 11.540 C 17.488 11.433,16.190 10.103,13.641 7.544 C 9.354 3.241,7.242 1.174,7.051 1.094 C 6.887 1.025,6.417 1.027,6.256 1.097 ",
		stroke: "none",
		fillRule: "evenodd"
	})
});
export default SvgCaretRight;
